
import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api'; 

export interface WellSummaryRequest {
  mopCsv?: string;
  businessUnitCsv?: string;
  fieldCsv?: string;
  groupCsv?: string;
}

export type WellSummaryApiResponse = {
  values: Array<{
    mop: string;
    mopData: Array<{ status: string; count: number }>;
  }>;
  id?: string;
  dateCreated?: string;
};

export const fetchServerFilteredWellSummary = createAsyncThunk<
  WellSummaryApiResponse,
  WellSummaryRequest | undefined,
  { rejectValue: string }
>('wellFilters/fetchServerFilteredWellSummary', async (body = {}, { rejectWithValue }) => {
  try {
    const res = await api.post<WellSummaryApiResponse>('/WellSummary', body);
    return res.data;
  } catch (err: any) {
    return rejectWithValue(err?.response?.data?.message || err?.message || 'Failed to fetch filtered well summary');
  }
});
